module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicWide-Light-fb0470a2e1eeff30f3fe8b6385a5957b.woff";